import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@ngrx/store';
import { DeviceSyncStatusSelectors } from '../../sub-features/device-sync/device-sync-statuses-store';
import { DeviceSyncStatusComponent } from './device-sync-status.component';

@Component({
  selector: 'era-device-sync-status',
  templateUrl: './device-sync-status.container.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DeviceSyncStatusComponent],
})
export class DeviceSyncStatusContainerComponent {
  private readonly store = inject(Store);

  public readonly deviceStatus = this.store.selectSignal(DeviceSyncStatusSelectors.selectCurrentDeviceSyncStatus);
}
